import Image from 'app/Components/Shared/Image/image';
import React ,{useState,useEffect,useRef} from 'react'
import Config from '../../../../Config';
import CancelPackagePopUp  from './PopUps/CancelPackagePopUp';
import PackageDetailsPopup  from './PopUps/PackageDetailsPopup';
import PopUp from '../../../Shared/Popup/PopUp';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {clearScreenILAddon} from '../cellcomAbroadBlockSlice';
import {connect} from 'react-redux';
import CancelAddonPackagePopUp from './PopUps/CancelAddonPackagePopUp';
import { gaExistingAddonsDetails ,gaCancelAddonsStep1} from '../../AbroadTicketBlock/gaReports';
import { dwhAbroadAddonExistingPage ,dwhRemoveAbroadAddon} from '../dwhReports';
import { removePackage } from '../Shared/abroadThunk';

 const AbroadScreenIlAddon = ({
  couponData,
  subscriber,
  removePackage,
  clearScreenILAddon,
  cellcomAbroad,
  userData}) => {

  const [popUpDisplay, setPopUpDisplay] = useState('');
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const popUpObject = {
    showInfoPopUp: 'showInfoPopUp',
    showCancelPackagePopUp: 'showCancelPackagePopUp',
    failedCancelPackage: 'FailedCancelPackage',
  };


  const params ={
    channel : cellcomAbroad.activeLobbyTab && cellcomAbroad.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1 : cellcomAbroad.isJETAuthentication ? 'JET' : 'WEBSITE',
    param2 : couponData.socCode,
    param3 : cellcomAbroad.selectedAbroadPackage?.isFamilyBonus?'בני משפחות':cellcomAbroad.epiStyleInitializationData.businessIndividualLobby?'Individual':'',
    param4 : userData?.contactNumber,
    param5 : cellcomAbroad.selectedCountries.map(c => c.countryCode).join(','),
    costumerName: userData?.firstName +' '+ userData?.lastName,
    idNumber : userData?.IDNumber,
    subscriber: subscriber,
  }

 useEffect(() => {
    dwhAbroadAddonExistingPage({message: 'Existing Addon Displayed', ...params});
  }, []);

  function openInfoPopup(){
    setPopUpDisplay(popUpObject.showInfoPopUp);
    gaExistingAddonsDetails(couponData.packageName);
  }
  function openCancelPopup(){
    dwhAbroadAddonExistingPage({message: 'Addon Cancel Button Clicked', ...params});
    setPopUpDisplay(popUpObject.showCancelPackagePopUp);
    gaCancelAddonsStep1(couponData.packageName);
  }

  async function cancelPackage() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventParams
    );

    const removeSocData = {
      soc: couponData.socCode,
      mobile: subscriber,
      startDate: '',
      shouldRemoveSurfingBlockSoc: false,
      isAddon: true
    };

    await removePackage(removeSocData).then(res=>{
      if(res.payload?.Body.isSuccess ){
        dwhRemoveAbroadAddon({message: 'Success', status: 'Completed', ...params});
        clearScreenILAddon();
     }
     else{
      dwhRemoveAbroadAddon({message: 'General Error', status: 'Error', ...params});
     }
    });

    if (isMounted.current) setPopUpDisplay('');
   }
      useEffect(() => {
      if (popUpDisplay) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'auto';
      }
    }, [popUpDisplay]);

  const renderPopUps=()=>{
    return(
        <PopUp  showPopUp={popUpDisplay} onClose={()=>{setPopUpDisplay('')}}>
          {popUpDisplay== popUpObject.showCancelPackagePopUp &&
           <CancelAddonPackagePopUp cancelPackage={cancelPackage} onClose={()=>{setPopUpDisplay('')}} dwhParams={params} socTitle={couponData.packageName}/>}
          {popUpDisplay== popUpObject.showInfoPopUp &&
           <PackageDetailsPopup  packageData={couponData} />}
        </PopUp>
    )
  }
    return (
      <>
    <div className='abroad-additional-services-item'>
          <div className='description-container'>
              <Image className='item-img' src={Config.epiBaseUrl + couponData.icon} />
              <div className='item-title-1'> חבילת {couponData.packageName} </div>
              <div className='item-title-2'>
                            <span style={{ fontWeight: "bold" }}>למנוי{ ' ' + subscriber + ' '}</span>
                            <span> קיימת חבילה {couponData.title}</span>
                </div>
                <div className='item-title-2'>
                            <span style={{ fontWeight: "bold" }}> קוד קופון</span>
                            &nbsp;{couponData.activationCode}
                </div>
          </div>
          <div className='action-container'>
              <div className='action' onClick={() =>openInfoPopup()}>
                  {'פרטים נוספים > '}
                </div>
                {couponData.permissions.canCancelPurchuse &&
                <div className='action' onClick={() => openCancelPopup()}>
                  {'ביטול חבילה > '}
              </div>
              }
          </div>
      </div>
      {popUpDisplay && renderPopUps()}
      </>
    )
}

const mapStateToProps = (state) => ({
  cellcomAbroad: state.cellcomAbroad,
  userData:state.authentication?.loginData?.userDetails,
});
const mapDispatchToProps = {
  removePackage,
  clearScreenILAddon,
};

export default connect(mapStateToProps, mapDispatchToProps)( AbroadScreenIlAddon);

